module.exports = __webpack_public_path__ + "img/c.e23139a2.jpg";